import { render, staticRenderFns } from "./Approved.vue?vue&type=template&id=14b557a9&class=py-5&"
import script from "./Approved.vue?vue&type=script&lang=js&"
export * from "./Approved.vue?vue&type=script&lang=js&"
import style0 from "./Approved.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports